<template>
  <v-container grid-list-xl>
    <v-layout wrap>
      <!-- HEADER -->
      <v-flex xs12>
        <h1 class="headline">Tools On Site</h1>
      </v-flex>

      <!-- Searh tools on site -->
      <v-flex xs12 sm6>
        <div class="subheading mb-4">
          You are responsible for the tools listed for your Job site.
          <span class="caption"
            ><br />* If the list shown here doesn not match your tools on site
            please contact Alan Byrne immediately at
            <a href="mailto:alan@albademo.com" class="blue--text text--darken-4"
              >alan@albademo.com</a
            ></span
          >
        </div>
        <job-selector @jobSiteChange="updateJobSite" :whiteBg="true" />
        <v-btn @click="getToolsOnSite" color="primary" :disabled="!jobSite">
          <v-icon left>location_city</v-icon>Get Tools on site
        </v-btn>
      </v-flex>

      <!-- Tool list -->
      <v-flex xs12 v-if="!loading && toolsOnSite.length">
        <div class="pb-4 title">
          <span class="font-weight-regular d-inline-block pr-3"
            >Tools on site value:</span
          >
          <strong style="border-bottom: solid 3px green"
            >${{ toolsOnSiteValue }}</strong
          >
        </div>
        <tos-table :toolsOnSite="toolsOnSite" />
        <!-- <v-data-table
          :headers="headers"
          :items="toolsOnSite"
          :items-per-page="500"
          item-key="id"
          disable-sort
          hide-default-footer
        >
          <template v-slot:item.image="{ item }">
            <div class="py-1">
              <v-img :src="item.image" width="50" height="50" contain />
            </div>
          </template>
          <template v-slot:item.title="{ item }">
            <div>
              {{ item.title }}
            </div>
            <div>
              <span class="caption green--text text--darken-4"
                >Value: ${{ item.unitPrice.toFixed(2) }}</span
              >
            </div>
          </template>
        </v-data-table> -->
      </v-flex>
      <v-flex xs12 v-if="loading">
        <v-progress-circular
          indeterminate
          color="primary"
          class="mr-4"
        ></v-progress-circular>
        <span class="caption">Getting tools on site...</span>
      </v-flex>
      <v-flex xs12 v-if="!loading">
        <div class="grey--text">{{ noToolsMessage }}</div>
      </v-flex>
    </v-layout>
  </v-container>
</template>
<script>
import utils from "@/helpers/utils";
import JobSelector from "../components/JobSelector";
import TosTable from "../components/toolPickups/TosTable";
export default {
  components: { JobSelector, TosTable },
  data() {
    return {
      loading: false,
      jobOrders: [],
      jobSite: null,
      labels: [],
      value: [],
      toolsOnSite: [],
      headers: [
        {
          text: "",
          align: "left",
          sortable: false,
          value: "image",
          width: 50,
        },
        { text: "Title", value: "title" },
        {
          text: "Qty On Site",
          value: "totalQty",
          align: "center",
          width: "100",
        },
      ],
      noToolsMessage: "",
      toolsOnSiteValue: "",
    };
  },
  async created() {},
  methods: {
    async getToolsOnSite() {
      this.noToolsMessage = "";
      this.loading = true;
      try {
        const res = await utils.getToolsOnSite(this.jobSite);
        if (res.msg) {
          this.loading = false;
          this.noToolsMessage = res.msg;
        } else {
          this.loading = false;
          this.toolsOnSite = res.toolsOnSite;
          this.jobOrders = res.jobOrders;
          this.toolsOnSiteValue = res.toolsOnSiteValue;
        }
      } catch (error) {
        alert("Error getting tools on site.");
        this.loading = false;
        console.log(error.message);
      }
    },
    updateJobSite(jobSite) {
      if (!jobSite) {
        this.toolsOnSite = [];
      }
      this.jobSite = jobSite;
    },
  },
};
</script>

<style scoped>
.v-sheet--offset {
  top: -24px;
  position: relative;
}
</style>
